import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import currencyFormat from 'src/utils/formatCOP';
import onMouseResultsMap from 'src/utils/onMouseResultsMap';
import { useStyles, StyledTableCell } from '../reportsBoard/styles';
import LoadingRows from './LoadingRows';

const TableIndustry = ({
  array = [],
  selectedDate,
  title = '',
  param,
  param1Tsum = 'VALOR1',
  param2Tsum = 'VALOR2',
}) => {
  const classes = useStyles();

  return (
    <>
      <TableContainer component={Paper}>
        <Table className={classes.table} size="small" aria-label="spanning table">
          <TableHead>
            <TableRow>
              <StyledTableCell colSpan={4} align="center">
                Unidades Enero - Diciembre
              </StyledTableCell>
              <StyledTableCell colSpan={3} align="center">
                Participación del mercado
              </StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableCell align="center">{title}</StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear()}</StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear() - 1}</StyledTableCell>
              <StyledTableCell align="right">
                {selectedDate.getFullYear()}
                {' '}
                VS
                {' '}
                {selectedDate.getFullYear() - 1}
              </StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear()}</StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear() - 1}</StyledTableCell>
              <StyledTableCell align="right">
                {selectedDate.getFullYear()}
                {' '}
                VS
                {' '}
                {selectedDate.getFullYear() - 1}
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {array.length > 0 ? (
              array.map((row) => (
                <TableRow key={Math.random()}>
                  <TableCell align="left">{row[param].toUpperCase()}</TableCell>
                  <TableCell align="right">{currencyFormat(parseInt(row.VALOR1 || row.PERIODO1 || 0, 10))}</TableCell>
                  <TableCell align="right">{currencyFormat(parseInt(row.VALOR2 || row.PERIODO2 || 0, 10))}</TableCell>
                  <TableCell align="right">
                    {(+row.VS || +row.VERSUS || +row.AA || 0).toFixed(2)}
                    %
                  </TableCell>
                  <TableCell align="right">
                    {(+row.MS1 * 100 || 0).toFixed(2)}
                    %
                  </TableCell>
                  <TableCell align="right">
                    {(+row.MS2 * 100 || 0).toFixed(2)}
                    %
                  </TableCell>
                  <TableCell align="right">{(+row.DIFMS * 100 || 0).toFixed(2)}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                  <TableCell><LoadingRows /></TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell>TOTAL</TableCell>
              <TableCell align="right">{onMouseResultsMap.totals(array, param1Tsum)}</TableCell>
              <TableCell align="right">{onMouseResultsMap.totals(array, param2Tsum)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TableIndustry;
